<template>
  <div class="dislogbox" v-if="socket.dislog.his" >
    <div class="historylist">
      <div class="tab">
        <div class="tp">
          <div class="find">
            <input type="text" placeholder="搜索" v-model="form.message"  @keydown.enter="searchEvent"/>
            <a class="back" href="javascript:void(0);" @click="rest"></a>
          </div>
          <div class="tabul">
            <a href="javascript:void(0);" @click="changeType(i.value)" v-for="i in typeList" :class="{'cur':form.type==i.value}">{{i.name}}</a>
          </div>
        </div>
      </div>
      <div class="box-bd" id="nbox-bd" ref="nscrollRef">
          <a href="javascript:void(0);" class="more" v-if="!ismore && isload" @click="readMore">查看更多消息</a>
          <div class="message-box" v-for="data in comments">
            <ChatBox :data="data" :user="socket.group" :isHis="true"/>
          </div>
          <div v-if="comments.length==0 && ismore && !form.type" class="nofind">没有找到与"<span>{{searchText}}</span>" 相关的记录</div>
          <div v-if="comments.length==0 && ismore && form.type" class="nofind">无内容</div>
      </div>
    </div>
  </div>
</template>
<script setup>
	import ChatBox from '@/components/chat/ChatBox'
  import { ref,reactive,nextTick} from 'vue';
  const comments = ref([]);
	import { useSocket } from "@/stores/index";
  const socket = useSocket();
  const ismore=ref(false);
  const isload=ref(false);
  const searchText=ref('');
  const nscrollRef=ref(null);
  const form=reactive({
    message:'',
    minId:'',
    type:null,
  })
  const typeList=ref([
    {name:'图片',value:20},
    { name:'订单', value:40},
    { name:'商品',value:50 }
  ]);

  const changeType=(type)=>{
    if(form.type==type) return 
    form.type=type;
    form.message='';
    search();
  }
  function toScroll() {
    setTimeout(() => {
      var div = document.getElementById("nbox-bd")
      if(div){
        div.scrollTop = div.scrollHeight
      }
    }, 200);
  }  
  const readMore =async () => {
    const scrollTopBefore = nscrollRef.value.scrollTop;
		const scrollHeightBefore = nscrollRef.value.scrollHeight;
    if(ismore.value===true) return false;
    const list= await socket.getHistory(form)
    isload.value=true;
    if(list.length){
      form.minId=list[0].id
    }
    if(list.length<20){ismore.value=true;}
    comments.value = [...list, ...comments.value]
    nextTick(() => {
			const scrollHeightAfter = nscrollRef.value.scrollHeight;
			nscrollRef.value.scrollTop = scrollHeightAfter - scrollHeightBefore + scrollTopBefore;
	 });
	}
  const loadData = async (isbot) => {
    if(ismore.value===true) return false;
    const list= await socket.getHistory(form)
    isload.value=true;
    if(list.length){
      form.minId=list[0].id
    }
    if(list.length<20){ismore.value=true;}
    comments.value = [...list, ...comments.value]
    toScroll()
  }
  const search=async()=>{
    isload.value=false;
    form.minId='';
    comments.value = []
    ismore.value=false;
    await loadData()
    // scrollbarRef.value.setScrollTop(innerRef.value.clientHeight)
  }
  const searchEvent=async ()=>{
    form.type=undefined;
    searchText.value=JSON.parse(JSON.stringify(form.message));
    search();
  }
  const rest=()=>{
    isload.value=false;
    ismore.value=false;
    searchText.value=''
    form.type=undefined;
    form.minId='';
    form.message='';
    comments.value = []
    socket.seeOP('his',false)
  }
  
  defineExpose({
    loadData,
    rest
  });
</script>
<style lang="scss" scoped>
.dislogbox{
  position: fixed;
  z-index: 999;
  left:0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0,0.4);
}
.historylist{
  position: absolute;
  left:5%;
  top: 5vh;
  height: 90vh;
  width: 90%;
  background: #f5f7f8;
  display: flex;
  flex-direction: column;
  border-radius:10px;
  .nofind{
    text-align: center;
    padding-top: 50px;
  }
  .tab{
    border-bottom: 1px solid #f0f0f0;
    position: relative;
    background: #fff;
    .back{
      width: 20px;
      height: 20px;
      background: url('../../assets/images/close.png') no-repeat;
      background-size: 100% 100%;
      display: inline-block;
    }
    .find{
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      input{
        width: 90%;
        box-sizing: border-box;
        height: 30px;
        background: #f0f0f0;
        border:0 none;
        padding: 0 10px;
        border-radius: 6px;
        font-size: 14px;
      }
    }
    .tabul{
      display: flex;
      padding-bottom:10px;
      a{
        color:#666;
        font-size: 14px;
        line-height:24px;
        width: 60px;
        text-align: center;
      }
      .cur{
        color:#009cde
      }
    }
  }
}
</style>